import { render, staticRenderFns } from "./RegalaIscrizioneBegin.vue?vue&type=template&id=0b1f0034&scoped=true&"
import script from "./RegalaIscrizioneBegin.vue?vue&type=script&lang=js&"
export * from "./RegalaIscrizioneBegin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f0034",
  null
  
)

export default component.exports